import { createFileRoute } from '@tanstack/react-router';
import { AuditPage } from '@/features/admin';

export const Route = createFileRoute('/_auth/o/$orgId/admin/audit')({
  component: AuditPage,
});
